import { StaleBuildReload } from "@/components/StaleBuildReload";
import { isChunkLoadError } from "@/lib/stale-build";
import type { DefaultComponentModule } from "@/types/routes";

/** Adapt a default-exported page to React Router's lazy route-module shape. */
export function lazyPage(load: () => Promise<DefaultComponentModule>) {
  return async () => {
    try {
      const page = await load();
      return { Component: page.default };
    } catch (error) {
      // A deploy removed this chunk while the tab was open. Resolving lets the
      // router land on the page's URL, so the reload opens the page that was
      // clicked. Throwing would also leave React Router 7 rendering an empty
      // outlet for a lazy route with its own errorElement.
      if (isChunkLoadError(error)) return { Component: StaleBuildReload };
      throw error;
    }
  };
}
